// CleverReach API Integration
// Documentation: https://rest.cleverreach.com/explorer/v3/

export enum CleverReachList {
    general,
    kids_teens
}

export type CleverReachSubscriberData = {
    email: string;
    attributes: {
        datenschutz_ok: boolean;
    };
    global_attributes?: {
        firstname?: string;
        lastname?: string;
        [key: string]: string | number | undefined;
    };
    tags?: string[];
    source?: string;
};

export type CleverReachSubscriber = {
    registered: number;
    activated: number;
    postdata?: {
        activate: boolean;
    };
} & CleverReachSubscriberData;

export type CleverReachResponse = {
    success: boolean;
    message?: string;
    error?: string;
    isDuplicate?: boolean;
};

export type CleverReachSecrets = {
    clientId: string;
    clientSecret: string;
    tokenUrl?: string;
};
